"use strict";

const EventImpl = require("./Event-impl").implementation;

const HashChangeEventInit = require("../generated/HashChangeEventInit");

class HashChangeEventImpl extends EventImpl {

}
HashChangeEventImpl.defaultInit = HashChangeEventInit.convert(undefined);

module.exports = {
  implementation: HashChangeEventImpl
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/jsdom/lib/jsdom/living/events/HashChangeEvent-impl.js
// module id = sYMG
// module chunks = 0